<div class="d-flex w-100 h-100 justify-content-center">
  <div class="d-flex flex-column my-xxl-5">
    <p-progressSpinner class="mx-auto"></p-progressSpinner>
    <p>Validating callback parameters received from Vendor Platform</p>
  </div>
</div>
